<mat-card>
  <mat-card-content>
    <ejs-grid #grid id="grid" [dataSource]="positionen" [editSettings]="editSettings!" [toolbar]="toolbar" height="260px" locale="de-CH" (actionComplete)="onActionComplete($event)">
      <e-columns>
        <e-column field="id_ObjektRapportPosition" [defaultValue]="getDefaultID()" headerText="Product ID" textAlign="Right" isPrimaryKey="true" width="0"></e-column>
        <e-column field="datum" [defaultValue]="getDefaultDatum()" headerText="Datum" width="95"></e-column>
        <e-column field="mitarbeiter" [defaultValue]="getDefaultMitarbeiter()" headerText="Mitarbeiter" width="130"></e-column>
        <e-column field="arbeitsbezeichnung" headerText="Arbeitsbeschreibung" width="300"></e-column>
        <e-column field="aufwandInStunden" headerText="Aufwand in h" editType="numericedit" width="100" textAlign="Right"></e-column>
        <e-column field="preis" [defaultValue]="getDefaultAnsatz()" headerText="Stundenansatz" editType="numericedit" width="120" format="C2" textAlign="Right"></e-column>
        <e-column field="rabatt" headerText="" editType="numericedit" width="80" [valueAccessor]="valueAccess" textAlign="Right"></e-column>
        <e-column field="total" headerText="Total" width="120" [allowEditing]='false' [valueAccessor]="totalPosition" format="C2" textAlign="Right"></e-column>
      </e-columns>

      <e-aggregates>
        <e-aggregate>
          <e-columns>
            <e-column columnName="preis" type="Custom">
              <ng-template #footerTemplate let-data>Total exkl.</ng-template>
            </e-column>
            <e-column columnName="total" type="Custom" [customAggregate]="customAggregateTotalExkl">
              <ng-template #footerTemplate let-data>{{ data.Custom }}</ng-template>
            </e-column>
          </e-columns>
        </e-aggregate>
        <e-aggregate>
          <e-columns>
            <e-column columnName="preis" type="Custom">
              <ng-template #footerTemplate let-data>{{ mwstSatz }}% MwSt.</ng-template>
            </e-column>
            <e-column columnName="total" type="Custom" [customAggregate]="customAggregateMwSt">
              <ng-template #footerTemplate let-data>{{ data.Custom }}</ng-template>
            </e-column>
          </e-columns>
        </e-aggregate>
        <e-aggregate>
          <e-columns>
            <e-column columnName="preis" type="Custom">
              <ng-template #footerTemplate let-data>Total inkl.</ng-template>
            </e-column>
            <e-column columnName="total" type="Custom" [customAggregate]="customAggregateTotalInkl">
              <ng-template #footerTemplate let-data>{{ data.Custom }}</ng-template>
            </e-column>
          </e-columns>
        </e-aggregate>
      </e-aggregates>
    </ejs-grid>

    <div>
      <canvas #sigCanvas height="150" width="800" style="background: url('src/assets/images/signature.png')">
      </canvas>
    </div>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="createRapport()" [disabled]="rapportIsCreated" [innerText]="'MAIN_APP_OBJECTS.createRapport' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" (click)="showRapport()" [disabled]="!rapportIsCreated" [innerText]="'MAIN_APP_OBJECTS.rapportAnzeigen' | translate"></button>
    <button mat-stroked-button class="cancel" (click)="clearSignature()" [disabled]="rapportIsCreated" [innerText]="'MAIN_APP_OBJECTS.unterschriftLoschen' | translate"></button>
  </mat-dialog-actions>

  <mat-dialog-actions>
	  <button (click)="save()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
